export default "__VITE_ASSET__2c686530__"